/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimulationKeyFigure
 */
export interface SimulationKeyFigure {
    /**
     * 
     * @type {string}
     * @memberof SimulationKeyFigure
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationKeyFigure
     */
    previousYearValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationKeyFigure
     */
    currentYearValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationKeyFigure
     */
    simulationYearValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationKeyFigure
     */
    deviation?: string | null;
}

/**
 * Check if a given object implements the SimulationKeyFigure interface.
 */
export function instanceOfSimulationKeyFigure(value: object): value is SimulationKeyFigure {
    return true;
}

export function SimulationKeyFigureFromJSON(json: any): SimulationKeyFigure {
    return SimulationKeyFigureFromJSONTyped(json, false);
}

export function SimulationKeyFigureFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationKeyFigure {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'previousYearValue': json['previousYearValue'] == null ? undefined : json['previousYearValue'],
        'currentYearValue': json['currentYearValue'] == null ? undefined : json['currentYearValue'],
        'simulationYearValue': json['simulationYearValue'] == null ? undefined : json['simulationYearValue'],
        'deviation': json['deviation'] == null ? undefined : json['deviation'],
    };
}

export function SimulationKeyFigureToJSON(json: any): SimulationKeyFigure {
    return SimulationKeyFigureToJSONTyped(json, false);
}

export function SimulationKeyFigureToJSONTyped(value?: SimulationKeyFigure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'previousYearValue': value['previousYearValue'],
        'currentYearValue': value['currentYearValue'],
        'simulationYearValue': value['simulationYearValue'],
        'deviation': value['deviation'],
    };
}

